<template>
  <main class="row q-gutter-x-xs">
    <section class="col">
      <q-table
        style="height: 500px"
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        dense
        v-model:pagination="pagination"
        class="q-mt-md tabela-tamanho-fixo"
        color="primary"
        row-key="id"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
        @request="handleRequest"
      >
        <template v-slot:top-left>
          <lista-unidades-select
            style="margin-left: -15px"
            :todos="true"
            v-model="unidadeSelected"
          ></lista-unidades-select>
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <template #body-cell-requisitante="props">
          <q-td>
            <div class="row col-12 justify-center">
              <q-btn
                v-if="props"
                color="secondary"
                icon="add"
                no-caps
                round
                dense
                @click="adicionarRequisitante(props.row.id)"
              />
            </div>
          </q-td>
        </template>
        <template #body-cell-aprovador="props">
          <q-td>
            <div class="row col-12 justify-center">
              <q-btn
                v-if="props"
                color="positive"
                icon="add"
                round
                dense
                no-caps
                @click="adicionarAprovador(props.row.id)"
              />
            </div>
          </q-td>
        </template>
      </q-table>
    </section>
    <section class="col">
      <q-table
        style="height: 500px"
        flat
        dense
        table-header-class="bg-accent text-width-bold"
        :rows="rows2"
        :loading="disable"
        :columns="columns2"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="id"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
        :filter="filtrar2"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar2"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <template #body-cell-nome="props">
          <q-td>
            {{ props.row.name }}
          </q-td>
        </template>
        <template #body-cell-aprovador="props">
          <q-td>
            <span v-if="props.row.pivot.approver == 1">SIM</span>
            <span v-else>NÃO</span>
          </q-td>
        </template>
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              v-if="props"
              color="negative"
              round
              no-caps
              icon="delete"
              @click="deletarCentro(props.row.id)"
            />
          </q-td>
        </template>
      </q-table>
    </section>
  </main>
</template>

<script>
const columns = [
  {
    name: "code",
    label: "Código",
    field: "id",
    align: "left",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "vendor",
    label: "Unidade",
    field: (row) => row.vendor.name,
    align: "left",
  },
  {
    name: "requisitante",
    label: "Add. Req",
    field: "email",
    align: "left",
  },
  {
    name: "aprovador",
    label: "Add. Aprovador",
    field: "email",
    align: "left",
  },
];

const columns2 = [
  {
    name: "code",
    label: "Código",
    field: "id",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "vendor",
    label: "Unidade",
    field: (row) => row.vendor.name,
    align: "left",
  },
  {
    name: "aprovador",
    label: "Aprovador",
    field: (row) => row.pivot.approver,
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "email",
    align: "center",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";
import { ref, onMounted, computed, watch } from "vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const disable = ref(true);
    const rows = ref([]);
    const rows2 = ref([]);
    const route = useRoute();
    const filtrar = ref("");
    const filtrar2 = ref("");

    const unidadeSelected = ref();
    const quasar = useQuasar();
    const id = route.params.id;
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getCentros = async (page = 0, rowsPerPage = 15) => {
      disable.value = true;
      try {
        let response = await store.dispatch("user/getCentros", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: rowsPerPage,
          search: filtrar.value,
        });

        rows.value = response.data.results.data;

        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getCentros);

    const getCentrosAssociados = async () => {
      disable.value = true;
      try {
        let response = await store.dispatch("user/getUserEspecifico", {
          id,
        });

        rows2.value = response.data.model.cost_centers;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getCentrosAssociados);

    const deletarCentro = async (center_id) => {
      try {
        await store.dispatch("user/deletarCentro", {
          id,
          center_id,
        });

        getCentros();
        getCentrosAssociados();
      } catch (error) {
        quasar.notify({
          message: "Erro a o remover centro",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    watch(
      () => store.state.org.unidadeData,
      () => {
        getCentros();
        getCentrosAssociados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidadeSelected.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const adicionarAprovador = async (id_centro) => {
      try {
        let objeto = [{ cost_center_id: id_centro, approver: 1 }];

        await store.dispatch("user/adicionarAprovadorRequisitante", {
          id,
          cost_centers: objeto,
        });

        getCentros();
        getCentrosAssociados();
      } catch (error) {
        quasar.notify({
          message: "Erro a o remover centro",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarRequisitante = async (id_centro) => {
      try {
        let objeto = [{ cost_center_id: id_centro, approver: 0 }];

        await store.dispatch("user/adicionarAprovadorRequisitante", {
          id,
          cost_centers: objeto,
        });

        getCentros();
        getCentrosAssociados();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o remover centro",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async (props) => {
      getCentros(props.pagination.page, props.pagination.rowsPerPage);
    };

    watch(
      () => filtrar.value,
      () => {
        getCentros();
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        getCentros();
      }
    );

    return {
      rows,
      disable,
      filtrar,
      columns,
      getCentros,
      handleRequest,
      pagination,
      getCentrosAssociados,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      columns2,
      rows2,
      filtrar2,
      adicionarAprovador,
      deletarCentro,
      adicionarRequisitante,
      unidadeSelected,
    };
  },
};
</script>

<style></style>
